// anhang_divider — full-bleed photograph with the big serif divider title (v15 slide 14:
// title 88px at x728/y462, mono label above it).
import type { AnhangDividerContent } from '../../../../shared/deckTypes.js';
import { Abs, Brand, Dkp, FramedImg, PageNo } from './chrome.js';

export default function AnhangDividerPreview({ content, pageNo }: {
  content: AnhangDividerContent;
  pageNo?: number | null;
}) {
  const c = content;
  // v15 «Vorgehen» sets the title alone bottom-left (x68/y328); «Anhang» sits right with the
  // sans description under it — the body decides the corner (same rule as the template).
  const right = !!c.body;
  const tx = right ? 728 : 68;
  const ty = right ? 454 : 320;
  return (
    <Dkp variant="photo">
      {c.image
        ? (
          <div className="dkp-bg" style={{ overflow: 'hidden' }}>
            <FramedImg src={c.image} content={c as Record<string, unknown>} slotKey="image" />
          </div>
        )
        : <div className="dkp-bg" style={{ background: '#0B0C0E' }} />}
      <div className="dkp-scrim" />

      {c.label ? (
        <Abs x={tx + 2} y={ty - 30} w={470}>
          <span className="dkp-mono" style={{
            fontSize: 11.5, letterSpacing: '.15em', textTransform: 'uppercase', color: '#D9D6CF',
            textShadow: '0 1px 8px rgba(11,12,14,.5)',
          }}>{c.label}</span>
        </Abs>
      ) : null}
      <Abs x={tx} y={ty} w={480}>
        <div className="dkp-serif" style={{
          fontSize: 88, lineHeight: 1.05, color: '#F3F1EC',
          textShadow: '0 2px 26px rgba(11,12,14,.55)',
        }}>
          {c.title}
          {c.title ? <span style={{ color: '#C8A96E' }}> ●</span> : null}
        </div>
      </Abs>
      {c.body ? (
        <Abs x={tx} y={588} w={480}>
          <div style={{ fontSize: 13.3, fontWeight: 500, color: '#D9D6CF', lineHeight: 1.5, textShadow: '0 1px 8px rgba(11,12,14,.5)' }}>{c.body}</div>
        </Abs>
      ) : null}

      <Brand light />
      <PageNo n={pageNo} light />
    </Dkp>
  );
}
